// Dictionary to translate permission codenames to Portuguese
export const getPermissionName = (codename) => {
  const permissionDict = {
    // User permissions
    'add_user': 'Adicionar usuário',
    'change_user': 'Editar usuário',
    'delete_user': 'Excluir usuário',
    'view_user': 'Visualizar usuário',
    
    // Student permissions
    'add_student': 'Adicionar estudante',
    'change_student': 'Editar estudante',
    'delete_student': 'Excluir estudante',
    'view_student': 'Visualizar estudante',

    // Student class permissions
    'view_studentclass_all': 'Visualizar todas as turmas',
    'view_studentclass_preschool': 'Visualizar turmas de pré-escolar',
    'view_studentclass_elementaryI': 'Visualizar turmas de ensino fundamental I',
    'view_studentclass_elementaryII': 'Visualizar turmas de ensino fundamental II',
    'view_studentclass_highschool': 'Visualizar turmas de ensino médio',

    // Student guardian permissions
    'view_student_guardian_all': 'Visualizar todos os responsáveis de estudante',
    
    // Authentication permissions
    'add_group': 'Adicionar grupo',
    'change_group': 'Editar grupo',
    'delete_group': 'Excluir grupo',
    'view_group': 'Visualizar grupo',
    'reenrollment_management': 'Gestão de rematrículas',
    
    // Content type permissions
    'add_permission': 'Adicionar permissão',
    'change_permission': 'Editar permissão',
    'delete_permission': 'Excluir permissão',
    'view_permission': 'Visualizar permissão',
    
    // Session permissions
    'add_session': 'Adicionar sessão',
    'change_session': 'Editar sessão',
    'delete_session': 'Excluir sessão',
    'view_session': 'Visualizar sessão',
    
    // Log entry permissions
    'add_logentry': 'Adicionar log',
    'change_logentry': 'Editar log',
    'delete_logentry': 'Excluir log',
    'view_logentry': 'Visualizar log',
    
    // Content type permissions
    'add_contenttype': 'Adicionar tipo de conteúdo',
    'change_contenttype': 'Editar tipo de conteúdo',
    'delete_contenttype': 'Excluir tipo de conteúdo',
    'view_contenttype': 'Visualizar tipo de conteúdo',
    
    // Add more permissions here as needed...
    // TODO: Expand this dictionary with more specific permissions
  };
  
  // Return the Portuguese translation if found, otherwise return the original codename
  return permissionDict[codename] || codename;
};

// Dictionary to translate model names to Portuguese
export const getModelName = (appLabel, model) => {
  const modelDict = {
    // Authentication app
    'auth.user': 'Usuários',
    'auth.group': 'Grupos',
    'auth.permission': 'Permissões',

    // Custom Authentication app
    'authentication.user': 'Usuários',
    'authentication.profile': 'Perfil de usuário',
    'authentication.global': 'Geral',
    
    // Student app (assuming you have this)
    'students.student': 'Alunos',
    'students.guardian': 'Responsáveis',
    'students.enrollment': 'Matrículas',
    'students.studentclass': 'Turmas',
    'students.studentlog': 'Logs de alunos',
    'students.studenttag': 'Etiquetas de alunos',
    'students.reenrollmentlog': 'Logs de rematrícula',
    'students.reenrollmentstatus': 'Status de rematrícula',

    // Reports app
    'reports.report': 'Relatórios',
    
    // Admin app
    'admin.logentry': 'Logs do Sistema',
    
    // Content types
    'contenttypes.contenttype': 'Tipos de Conteúdo',
    
    // Sessions
    'sessions.session': 'Sessões',
    
    // Add more model translations here as needed
  };
  
  const modelKey = `${appLabel}.${model}`;
  return modelDict[modelKey] || `${appLabel}.${model}`;
};

// Function to group permissions by app/model for better organization
export const groupPermissionsByModel = (permissions) => {
  const grouped = {};
  
  permissions.forEach(permission => {
    const { content_type } = permission;
    const modelKey = `${content_type.app_label}.${content_type.model}`;
    
    if (!grouped[modelKey]) {
      grouped[modelKey] = {
        app_label: content_type.app_label,
        model: content_type.model,
        model_name: getModelName(content_type.app_label, content_type.model),
        permissions: []
      };
    }
    
    grouped[modelKey].permissions.push(permission);
  });
  
  return grouped;
}; 